import type { MouseEventHandler } from 'react';

// Komponenten
import Icon from '@/comp/icon/icon';

// Types
import { PreloadedIconKey } from '@/_config/icons';

// Styles
import './button.scss';

export interface ButtonProps {
    label: string;
    classList?: string;
    icon?: PreloadedIconKey;
    valid?: boolean;
    validated?: boolean;
    type?: 'button' | 'submit' | 'reset';
    handleClick?: MouseEventHandler<HTMLButtonElement>;
}

function Button({
    label,
    classList = '',
    icon,
    valid = true,
    validated = false,
    type = 'button',
    handleClick = () => {},
}: ButtonProps) {
    return (
        <button
            type={type}
            onClick={handleClick}
            className={`button-element ${classList} ${valid ? 'valid' : 'invalid'} ${validated ? 'validate' : ''}`}>
            {/* label */}
            {label}

            {icon && valid && <Icon name={icon} size={19} ariaHidden />}

            {/* loader */}
            {validated && <span className="loader"></span>}
        </button>
    );
}

export default Button;
